//

import * as queryStringBase from './query-string';

export const queryString = queryStringBase;
